<template>
	<ModalFormCard
		:action="'/actions/user-update-password/' + user.id"
		class="modal-default"
	>
		<template #title>Edit users password</template>

		<template #default="{ saving, errors }">
			<Input
				v-if="user.hasRole('customer.owner')"
				v-model:value="value.current_password"
				class="mb-4"
				groupClass="bg-grey text-15"
				label="Current password"
				name="current_pwd"
				placeholder="Enter your password"
				type="password"
			/>

			<Input
				v-model:value="value.password"
				:type="canSeePassword ? 'text' : 'password'"
				groupClass="bg-grey text-15"
				label="New password"
				name="pwd"
				placeholder="Enter new password"
			>
				<template #right>
					<button
						class="w-10 h-10 flex items-center justify-center"
						type="button"
						@click="canSeePassword = !canSeePassword"
					>
						<IconRead
							v-if="!canSeePassword"
							class="h-auto w-6 stroke-black"
						/>
						<IconClose
							v-else
							class="h-4.5 w-4.5 stroke-black"
						/>
					</button>
				</template>
			</Input>

			<Input
				v-model:value="value.password_confirm"
				class="mt-4"
				groupClass="bg-grey text-15"
				label="Confirm password"
				name="pwd_confirmation"
				placeholder="Confirm password"
				type="password"
			/>

			<div class="pt-6 flex gap-4">
				<ButtonSaving :disabled="saving" class="button-black h-12 px-6">
					Update password
				</ButtonSaving>

				<ButtonSaving
					:disabled="saving"
					class="button-black-outline h-12 px-6"
					type="button"
					@click="generatePassword"
				>
					Generate password
				</ButtonSaving>
			</div>
		</template>
	</ModalFormCard>
</template>

<script>
import User from "~/models/user.js";
import Modal from "~/mixins/modal.js";

export default {
	mixins: [Modal],

	created() {
		this.setup(User, this.editingModel);
	},

	data() {
		return {
			canSeePassword: false,
		};
	},

	methods: {
		generatePassword() {
			this.value.password = this.$help.generatePassword();
			this.value.password_confirm = this.value.password;
			this.canSeePassword = true;
		},
	},

	computed: {
		user() {
			return this.editingModel;
		},
	},
};
</script>
